module.exports = __webpack_public_path__ + "img/3.12fe9ab4.webp";